import { createFileRoute } from '@tanstack/react-router';

function DashboardPage(): React.JSX.Element {
  return (
    <div className="flex flex-col gap-4 p-4 md:p-6 lg:p-8" data-testid="dashboard-page">
      <h1 className="text-2xl font-semibold">Dashboard</h1>
      <p className="text-sm text-muted-foreground">
        Practice metrics and activity summaries will appear here.
      </p>
    </div>
  );
}

export const Route = createFileRoute('/dashboard')({
  component: DashboardPage,
});
